import React from 'react'
import {
  Form,
  Icon,
  Input,
  Select,
  message,
  Row,
  Col,
  Descriptions,
} from 'antd'
import { MaintenanceFeeService, HomeService } from '../../../services'
import { number } from 'prop-types'
import { Moment } from '../../../helpers'
import './style.scss'
import NumberFormat from 'react-number-format'
const { Option } = Select
const formatTime = 'HH:mm'
const nowThaiYear = Moment()
  .add(543, 'years')
  .utc(7)
  .format('YYYY')
let uuid = 0

class TechnicianView extends React.Component {
  constructor() {
    super()
    this.state = {
      keys: [],
      homes: [],
      home: {},
      projects: [],
      loadingProject: false,
      loading: false,
      disabledSelectHome: true,
      itemId: number,
      item: {},
      currentTime: '',
      defaultRateFee: 25,
      landSize: 0,
      errors: {},
      grandTotal: 0,
      items: [],
    }
  }
  async showMessage(msg, duration = 3) {
    return await message.success(msg, duration)
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const editId = this.props.editId
    this.setState({ loading: true })
    this.props.form.validateFields((err, values) => {
      if (!err) {
        MaintenanceFeeService.update(editId, values)
          .then((rs) => {
            if (rs) {
              let msg = rs.data['message']
              this.setState({
                loading: false,
              })
              this.resetForm()
              this.showMessage(msg, 5)
              this.props.hideModal()
              this.props.reload()
            }
          })
          .catch((err) => {
            this.setState({
              loading: false,
            })
          })
      }
    })
  }

  UNSAFE_componentWillMount() {
    this.setState({
      itemId: this.props.editId,
      item: this.props.item,
      projects: this.props.projects,
    })
  }
  componentDidMount() {
    const { item } = this.state
    const { form } = this.props

    if (item.details) {
      this.setState({
        items: item.details,
      })
    }
    if (item.home_id) {
      this.getHome(item.home_id)
    }
  }

  getHome = (homeId) => {
    HomeService.view(homeId)
      .then((rs) => {
        if (rs) {
          this.setState({ home: rs.data['data'] })
        }
      })
      .catch((err) => this.setState({}))
  }
  getMaintenanceFee = (id) => {
    this.setState({
      item: {},
      items: [],
    })
    MaintenanceFeeService.view(id)
      .then((rs) => {
        if (rs) {
          this.setState({ item: rs.data['data'] })
          this.setState({ items: rs.data['data']['details'] })
        }
      })
      .catch((err) => this.setState({}))
  }

  totalPrice = () =>
    this.state.items.reduce((sum, item) => sum + parseFloat(item.total), 0)

  addRow = () => {
    let { defaultRateFee, landSize, home } = this.state
    var joined = this.state.items.concat({
      item_id: 0,
      year: nowThaiYear,
      title: 'ค่าบริการสาธารณะ',
      land_size: home.land_size ? home.land_size : 0,
      rate: defaultRateFee,
      start_date: Moment().utc(7),
      end_date: Moment().utc(7),
      day_count: 0,
      total: 0,
    })
    this.setState({ items: joined })
  }

  removeRow = (k) => {
    if (this.state.items.length === 0) {
      return
    }
    let items = [...this.state.items]
    const itemId = items[k].item_id
    MaintenanceFeeService.deleteDetail(itemId).then((rs) => {
      items.splice(k, 1)
      this.setState({
        items,
      })
      message.success('ลบรายการเรียบร้อย', 3)
    })
  }

  renderTableHeader() {
    return (
      <thead>
        <tr>
          <th align="center">
            <div align="center">ปี</div>
          </th>
          <th align="center">
            <div align="center">รายการ</div>
          </th>
          <th align="right">
            <div align="right">ขนาดที่ดิน</div>
          </th>
          <th align="right">
            <div align="right">อัตรา</div>
          </th>
          <th align="center">
            <div align="center">ตั้งแต่วันที่</div>
          </th>
          <th align="center">
            <div align="center">ถึงวันที่</div>
          </th>
          <th align="center">
            <div align="center">จำนวนวัน</div>
          </th>
          <th align="right">
            <div align="right">รวมเป็นเงิน</div>
          </th>
        </tr>
      </thead>
    )
  }

  renderTableData() {
    const { getFieldDecorator } = this.props.form
    if (this.state.items.length > 0) {
      return (
        <tbody>
          {this.state.items.map((item, index) => {
            if (item) {
              const {
                item_id,
                year,
                title,
                land_size,
                rate,
                start_date,
                end_date,
                day_count,
                total,
              } = item //destructuring
              return (
                <tr key={index}>
                  <td align="center">
                    {getFieldDecorator('item_id[' + index + ']', {
                      rules: [{ required: true, message: 'itemId' }],
                      initialValue: item_id,
                    })(<Input type="hidden" />)}
                    {year}
                  </td>
                  <td>{title}</td>
                  <td align="right">{land_size}</td>
                  <td align="center">{rate}</td>
                  <td align="center">
                    {Moment(start_date)
                      .utc(7)
                      .format('LL') || null}
                  </td>
                  <td align="center">
                    {Moment(end_date)
                      .utc(7)
                      .format('LL') || null}
                  </td>

                  <td align="center">{day_count}</td>
                  <td align="right">
                    {
                      <NumberFormat
                        value={total}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={''}
                      />
                    }
                  </td>
                </tr>
              )
            }
          })}
        </tbody>
      )
    }
  }

  render() {
    const { projects, homes, item } = this.state

    const formLayout = 'horizontal'
    const formItemLayout =
      formLayout === 'horizontal'
        ? {
            labelCol: {
              xs: { span: 24 },
              sm: { span: 4 },
              md: { span: 4 },
            },
            wrapperCol: {
              xs: { span: 24 },
              sm: { span: 20 },
              md: { span: 20 },
            },
          }
        : null
    const buttonItemLayout =
      formLayout === 'horizontal'
        ? {
            wrapperCol: {
              xs: { span: 24, offset: 0 },
              sm: { span: 20, offset: 4 },
              sm: { span: 20, offset: 4 },
            },
          }
        : null

    const listProjectItems = projects.map((item, index) => (
      <Option key={index} value={item.value}>
        {item.label}
      </Option>
    ))
    const listHomeItems = homes.map((item, index) => (
      <Option key={item.id} value={item.id}>
        {(item.homeType ? item.homeType.name : '') +
          (item.plan_no ? ' แปลง ' + item.plan_no : '') +
          (item.home_no ? ' (เลขที่ ' + item.home_no + ')' : '')}
      </Option>
    ))

    return (
      <React.Fragment>
        <Descriptions
          title={item.firstname + ' ' + item.lastname}
          bordered
          column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
        >
          <Descriptions.Item label="ID">{item.id}</Descriptions.Item>
          <Descriptions.Item label="ชื่อ">{item.firstname}</Descriptions.Item>
          <Descriptions.Item label="นามสกุล">{item.lastname}</Descriptions.Item>
          <Descriptions.Item label="ชื่อเล่น">
            {item.nickname}
          </Descriptions.Item>
          <Descriptions.Item label="โครงการ">
            {item.project ? item.project.name : null}
          </Descriptions.Item>
        </Descriptions>
      </React.Fragment>
    )
  }
}

export default TechnicianView
